import { Button, Typography } from "@mui/material";
import SpaTwoToneIcon from "@mui/icons-material/SpaTwoTone";
import GroupAddIcon from '@mui/icons-material/GroupAdd';

type DashboardButtonProps = {
  action: React.MouseEventHandler<HTMLButtonElement>;
  buttonLabel: string; 
};

export default function DashboardButton(props: DashboardButtonProps) {
  const { action, buttonLabel } = props;
  return (
    <Button
      sx={{
        minHeight: 120,
        borderRadius: "20px",
        boxShadow: 12,
        marginBottom: 3,
        flex: "start"
      }}
      fullWidth
      variant="contained"
      size="large"
      startIcon={
        <SpaTwoToneIcon sx={{ width: 55, height: 55, color: "#ffffff", textAlign: "left" }} />
      }
      onClick={action}
    >
      <Typography variant="h5" fontWeight="700" sx={{color: "#ffffff"}}>
        {buttonLabel}
      </Typography>
    </Button>
  );
}
